import React from 'react'
import PropTypes from 'prop-types'
import {UncontrolledTooltip} from 'reactstrap'

const propTypes = {
  inspectionCategoryTypes: PropTypes.array.isRequired
}

const InspectionTableHeaders = ({inspectionCategoryTypes}) => {
  return (
    <React.Fragment>
      {inspectionCategoryTypes.map(inspCatType =>
        <React.Fragment key={inspCatType.id}>
          <th id={`lt-insp-${inspCatType.id}`}>LT<br/>[mm]</th>
          <UncontrolledTooltip placement="right" target={`lt-insp-${inspCatType.id}`}>
            {`${inspCatType.name} length tested`}</UncontrolledTooltip>
          <th id={`dl-insp-${inspCatType.id}`}>DL<br/>[mm]</th>
          <UncontrolledTooltip placement="right" target={`dl-insp-${inspCatType.id}`}>
            {`${inspCatType.name} defected length`}</UncontrolledTooltip>
          <th id={`percent-insp-${inspCatType.id}`}>%</th>
          <UncontrolledTooltip placement="right" target={`percent-insp-${inspCatType.id}`}>
            {`${inspCatType.name} defected percent`}</UncontrolledTooltip>
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

InspectionTableHeaders.propTypes = propTypes

export default InspectionTableHeaders



// WEBPACK FOOTER //
// ./src/components/Report/defectivness/InspectionTableHeaders.js